import React from 'react';
import { Headline } from './components/Headline';
import { HeroImage } from './components/HeroImage';
import { SymptomIdentification } from './components/SymptomIdentification';
import { ProblemAgitation } from './components/ProblemAgitation';
import { Promise } from './components/Promise';
import { ProductPresentation } from './components/ProductPresentation';
import { Outcomes } from './components/Outcomes';
import { Science } from './components/Science';
import { WhoItsFor } from './components/WhoItsFor';
import { Testimonials } from './components/Testimonials';
import { WhatYouGet } from './components/WhatYouGet';
import { PriceAndCTA } from './components/PriceAndCTA';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { UrgencyClose } from './components/UrgencyClose';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-sage-light selection:text-forest-green" data-id="element-0">
      <RecentPurchaseToast data-id="element-1" />
      <main data-id="element-2">
        <Headline data-id="element-3" />
        <HeroImage data-id="element-4" />
        <SymptomIdentification data-id="element-5" />
        <ProblemAgitation data-id="element-6" />
        <Promise data-id="element-7" />
        <ProductPresentation data-id="element-8" />
        <Outcomes data-id="element-9" />
        <Science data-id="element-10" />
        <WhoItsFor data-id="element-11" />
        <Testimonials data-id="element-12" />
        <WhatYouGet data-id="element-13" />
        <PriceAndCTA data-id="element-14" />
        <Guarantee data-id="element-15" />
        <FAQ data-id="element-16" />
        <UrgencyClose data-id="element-17" />
      </main>
      <Footer data-id="element-18" />
    </div>;
}